export const GetSection = async () => {
    const respone = await fetch("api/Section/GetAll")
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {});
    return respone;
  };
  export const GetAllDepDivSec = async () => {
    const respone = await fetch("api/Section/GetAllDepDivSec")
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {});
    return respone;
  };